import { render, staticRenderFns } from "./Assesores.vue?vue&type=template&id=2980b5cb&scoped=true&"
import script from "./Assesores.vue?vue&type=script&lang=js&"
export * from "./Assesores.vue?vue&type=script&lang=js&"
import style0 from "./Assesores.vue?vue&type=style&index=0&id=2980b5cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980b5cb",
  null
  
)

export default component.exports